import { Navigate } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../i18n";

const STORAGE_KEY = "preferredLanguage";

export function detectLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;

  const browserLang = (navigator.language || DEFAULT_LANGUAGE).slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE;
}

export default function RootRedirect() {
  const lang = detectLanguage();
  return <Navigate to={`/${lang}/`} replace />;
}
